// extracted by mini-css-extract-plugin
module.exports = {"auto-complete":"style_auto-complete__yUhln"};